module.exports = __webpack_public_path__ + "img/maisou.c6362242.png";